import networkLink from "../util/network-link";

export const promoPage = (opt)=> {
    $(".p-btn__powerbook1-1").attr({href:`https://lineage.plaync.com/powerbook/wiki/%EA%B2%B0%EC%82%AC%EB%8C%80%EC%9D%98%20%EB%B3%B4%EA%B8%89%ED%92%88%20%ED%81%90%EB%B8%8C`});     // 결사대보급품
    $(".p-btn__powerbook1-2").attr({href:`https://lineage.plaync.com/powerbook/wiki/%EC%B9%BC%EB%B0%94%20%ED%8A%B8%EB%A1%9C%ED%94%BC`});     // 칼바트로피
    $(".p-btn__nshop").attr({href:`${networkLink[promokit.store("network")]}/lineage/goods/detail?dgi=412962&dci=1`});      // 영웅의장비패키지
    $(".p-btn__powerbook3-1").attr({href:`https://youtu.be/ScnsR14kyJ8`});      // 성장가이드
    $(".p-btn__powerbook3-3").attr({href:`https://lineage.plaync.com/powerbook/wiki/%EC%BA%90%EB%A6%AD%ED%84%B0%20%EC%84%B1%EC%9E%A5%20%EC%A7%80%EC%9B%90`});       // 초보자동선개편
    $(".p-btn__powerbook4-1").attr({href:`https://lineage.plaync.com/powerbook/wiki/%ED%98%88%EB%A7%B9+%EA%B3%B5%ED%97%8C%EB%8F%84+%EB%B0%8F+%EC%A3%BC%EA%B0%84+%EA%B0%9C%EC%9D%B8+%EA%B3%B5%ED%97%8C%EB%8F%84+%EC%8B%9C%EC%8A%A4%ED%85%9C`});     // 혈맹혜택

    promokit.page(
        $.extend(
            {
                el:'#container',
                type:'basic',
                cnb:true,
                topButton:true,
                footer:{
                    theme:'white'
                },
                headerButton:{
                    home:true,
                    event:true,
                    sns:true,
                    theme:'black'
                },
                caution:{
                    template:
                    `<ol>
                        <li>제재 계정 및 테스트 서버는 본 이벤트에 참여할 수 없습니다.</li>
                        <li>프로모션 페이지의 쿠폰은 계정당 1회 사용 가능하며 계정 명의와 동일한 명의의 휴대폰으로 본인 인증 후 수령 가능합니다.</li>
                    </ol>`
                }
            },
            opt || {}
        )
    );
};